import angular from 'angular';

angular.module('cxTable').directive('cxFilterColumn', [
  '$compile',
  function($compile) {
    var defaultOptions = {
      items: null, //Set to true to autogenerate else pass array or function that returns array
      itemTemplate: null,
      //Url to item template, it uses ng-include to display item in filter list (not tested)
      itemExpression: null, //Expression to execute for each item, use item.value in expression
      type: 'items', //Filter type, possible values: items, number, date
      search: false, //Show search box
      withoutMargin: false,
    };
    return {
      require: '^^cxTable',
      scope: true,
      link: function(scope, element, attrs, table) {
        if (typeof attrs.key === 'undefined' || attrs.key.length <= 0) {
          console.warn('[cxFilterColumn]: Missing "key" attribute');
          return;
        }
        /*Key attribute
         * Possible values:
         * name of property
         * array with names of properties */
        if (!scope.key) scope.key = scope.$eval(attrs.key) || attrs.key || '';
        var safeKey = (angular.isArray(scope.key) ? scope.key[0] : scope.key).toString();

        scope.filterItems = [];
        //Set filterOptions
        scope.filterOptions = angular.extend({}, defaultOptions, scope.$eval(attrs.cxFilterColumn));
        scope.isChanged = false;

        scope.initPopup = function() {
          //Function which is executed if the filter popup opens
          //It reads the filter settings from the table and initializes the popup
          scope.filterItems.clear();
          var propFilter = table.tableInfo.filters[safeKey];

          //Item filter: multiselect with checkboxes
          if (scope.filterOptions.type === 'items') {
            var items = scope.filterOptions.items;
            if (items) {
              if (typeof items === 'string') items = scope.$eval(items);
              if (items === true) {
                //Auto generate items
                //Try getting unique values from table rows
                items = table.rows.map(function(el) {
                  return el[safeKey];
                });
                items.sort();
                var li;
                for (var i = 0; i < items.length; i++)
                  if ((li = items.lastIndexOf(items[i])) !== i) items.splice(i + 1, li - i);
              } else if (items) {
                //Try getting the real array or function
                if (angular.isFunction(items)) items = items();
                //Return result from function
                if (!angular.isArray(items)) items = []; //Return array
              }
            }
            if (items) {
              angular.forEach(items, function(el) {
                var checked = false;
                if (
                  propFilter &&
                  typeof propFilter.items !== 'undefined' &&
                  angular.isArray(propFilter.items)
                ) {
                  checked = propFilter.items.indexOf(el) >= 0;
                }
                scope.filterItems.push({
                  value: el,
                  checked: checked,
                });
              });
            }
          }
          //Number compare filter
          if (scope.filterOptions.type === 'number') {
            if (typeof propFilter !== 'undefined') {
              scope.numberFilter.lesser =
                typeof propFilter.lesser !== 'undefined' ? propFilter.lesser : null;
              scope.numberFilter.greater =
                typeof propFilter.greater !== 'undefined' ? propFilter.greater : null;
            } else {
              scope.numberFilter = {
                lesser: null,
                greater: null,
              };
            }
          }
          //Date compare filter
          if (scope.filterOptions.type === 'date') {
            if (typeof propFilter !== 'undefined') {
              scope.dateFilter.lesser =
                typeof propFilter.lesser !== 'undefined' ? propFilter.lesser : null;
              scope.dateFilter.greater =
                typeof propFilter.greater !== 'undefined' ? propFilter.greater : null;
            } else {
              scope.dateFilter = {
                lesser: null,
                greater: null,
              };
            }
          }

          //Search box
          if (
            scope.filterOptions.search &&
            table.tableInfo.search &&
            table.tableInfo.search[safeKey]
          ) {
            scope.filterSearch = table.tableInfo.search[safeKey];
          } else {
            scope.filterSearch = '';
          }
          scope.isChanged = false;
        };

        scope.numberFilter = {
          lesser: null,
          greater: null,
        };
        scope.dateFilter = {
          lesser: null,
          greater: null,
        };
        scope.filterSearch = '';
        scope.search = function(term) {
          if (term) table.setSearch(safeKey, term);
          else {
            table.clearSearch(safeKey);
          }
          scope.closePopup();
        };
        scope.clearFilter = function() {
          table.clearFilter(safeKey);
          table.clearSearch(safeKey);
          scope.filterSearch = '';

          /* istanbul ignore else */
          if (scope.filterItems)
            angular.forEach(scope.filterItems, function(el) {
              el.checked = false;
            });

          scope.closePopup();
        };
        scope.isFiltered = function() {
          /* istanbul ignore if */
          if (!table.tableInfo.filters) return false;
          return (
            typeof table.tableInfo.filters[safeKey] !== 'undefined' ||
            table.tableInfo.search[safeKey]
          );
        };
        scope.filterPopupOpen = false;

        scope.searchOnEnter = function(event, value) {
          if (event.keyCode === 27) {
            scope.clearFilter();
          } else if (event.keyCode === 13) {
            /* istanbul ignore else */
            scope.search(value);
          }
        };

        scope.itemFilterChanged = function() {
          scope.closePopup();
          /* istanbul ignore if */
          if (scope.filterOptions.type !== 'items') return;
          var items = scope.filterItems
            .filter(function(el) {
              return el.checked;
            })
            .map(function(el) {
              return el.value;
            });
          if (items.length === 0) scope.clearFilter();
          else
            table.setFilter(safeKey, {
              items: items,
            });
        };
        scope.compareFilterChanged = function(value) {
          if (typeof value.lesser === 'undefined' || typeof value.greater === 'undefined') return;
          scope.closePopup();
          if (value.lesser !== null || value.greater !== null) {
            table.setFilter(safeKey, {
              lesser: value.lesser,
              greater: value.greater,
            });
          } else {
            scope.clearFilter();
          }
        };
        scope.compareFilterKeyPress = function(event, value) {
          if (event.keyCode === 27) {
            value.lesser = null;
            value.greater = null;
            scope.clearFilter();
          } else if (event.keyCode === 13) {
            /* istanbul ignore else */
            scope.compareFilterChanged(value);
          }
        };

        scope.closePopup = function() {
          scope.filterPopupOpen = false;
        };

        //Add clickable filter icon to element
        var icon = angular.element(
          scope.filterOptions.withoutMargin
            ? '<a><i class="fa fa-filter" ng-class="{\'red\':isFiltered()}"></i></a>'
            : '<a><i class="fa fa-filter margin10L" ng-class="{\'red\':isFiltered()}"></i></a>',
        );
        icon
          .attr(
            'uib-popover-template',
            "'assets/templates/common/table/filterColumnPopup.tpl.html'",
          )
          .attr('popover-append-to-body', true)
          .attr('popover-is-open', 'filterPopupOpen')
          .attr('popover-placement', 'bottom')
          .attr('popover-trigger', "'outsideClick'");
        $compile(icon)(scope);
        icon.bind('click', function() {
          scope.$apply(function() {
            //Toggle filter popup
            scope.filterPopupOpen = !scope.filterPopupOpen;
            if (scope.filterPopupOpen) scope.initPopup();
          });
          return false; //Prevent other click events
        });
        element.append(icon);
      },
    };
  },
]);
